/* Progressive enhancement only. Native details/menu, anchors and form work without JS. */
(() => {
  if (window.britberryNavigation) return;
  window.britberryNavigation = true;
  const media = matchMedia('(min-width: 1200px)');
  function setup(scope = document) {
    scope.querySelectorAll('[data-bb-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const sync = () => { menu.open = media.matches; };
      sync();
      const listener = () => { if (!menu.isConnected) media.removeEventListener('change', listener); else sync(); };
      media.addEventListener('change', listener);
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !media.matches) { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('.bb a[href^="#"]');
    if (!link || link.hasAttribute('data-bb-explorer-link') || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const hash = link.getAttribute('href');
    const target = document.getElementById(hash.slice(1));
    if (!target) return;
    event.preventDefault();
    if (target.matches('details')) target.open = true;
    if (hash === '#britberry-enquiry') {
      const reason = target.querySelector('select[name="contact[Enquiry]"]');
      const crop = target.querySelector('[data-bb-enquiry-crop-field]');
      if (reason) reason.value = link.dataset.bbEnquiry || 'Talk to a substrate specialist';
      if (crop && link.dataset.bbEnquiryCrop) crop.value = link.dataset.bbEnquiryCrop;
    }
    const menu = link.closest('[data-bb-menu]');
    if (menu && !media.matches) menu.open = false;
    const navHeight = document.querySelector('[data-bb-nav]')?.getBoundingClientRect().height || 0;
    const dawnHeight = document.querySelector('.shopify-section-header-sticky')?.getBoundingClientRect().height || 0;
    target.style.scrollMarginTop = `${navHeight + dawnHeight + 24}px`;
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll: true});
    target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once: true});
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    history.replaceState(null, '', hash);
  });
  // Align this page's subnavigation below an existing Dawn sticky header.
  const header = document.querySelector('.section-header');
  let navSection = document.querySelector('.bb-nav-section');
  if (header && navSection) {
    const update = () => {
      navSection = document.querySelector('.bb-nav-section');
      if (!navSection) return;
      const sticky = header.classList.contains('shopify-section-header-sticky') && !header.classList.contains('shopify-section-header-hidden');
      navSection.style.setProperty('--bb-header-offset', sticky ? `${header.getBoundingClientRect().height}px` : '0px');
    };
    document.addEventListener('shopify:section:load', update);
    new ResizeObserver(update).observe(header);
    new MutationObserver(update).observe(header, {attributes: true, attributeFilter: ['class']});
    update();
  }
})();
